import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/Documentation/Documentation/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2 {...{
      "id": "install-and-run-cezerin"
    }}>{`Install and Run Cezerin`}</h2>
    <p>{`Follow
`}<a parentName="p" {...{
        "href": "https://github.com/Cezerin2/cezerin2/blob/master/docs/using-source-code.md"
      }}>{`this`}</a>{`
installation guide for local environment. All the same for web deploy.`}</p>
    <p><a parentName="p" {...{
        "href": "https://github.com/Cezerin2/cezerin2/blob/master/docs/using-source-code.md"
      }}>{`Cezerin Installation Guide.`}</a></p>
    <p>{`Cezerin apps must be running, console command:`}</p>
    <pre><code parentName="pre" {...{}}>{`pm2 list all
`}</code></pre>
    <pre><code parentName="pre" {...{}}>{`root@ubuntu-s-1vcpu-1gb-nyc3-01:~# pm2 list all
┌───────┬────┬────────┬────────┬────────┬─────┬────────┬────────────┐
│ Name  │ id │ mode   │ status │ O      │ cpu │ memory │            |
├───────┼────┼────────┼────────┼────────┼─────┼────────┼────────────┤
│ api   │ 0  │ 0.33.0 │ fork   │ online │ 1   │ 0%     │ 139.4 MB   │
│ store │ 1  │ 0.33.0 │ fork   │ online │ 2   │ 0%     │ 136.4 MB   │
└───────┴────┴────────┴────────┴────────┴─────┴────────┴────────────┘

`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      